import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '..';

export default function CharacterBlockIcon({ color, className, size = 24, rotate, flip, style }: IConDefaultType) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5534 10.8989C13.4831 10.8989 15.0474 9.33463 15.0474 7.40498C15.0474 5.47532 13.4831 3.91103 11.5534 3.91103C9.62376 3.91103 8.05947 5.47532 8.05947 7.40498C8.05947 9.33463 9.62376 10.8989 11.5534 10.8989ZM11.5534 12.6459C14.4479 12.6459 16.7943 10.2995 16.7943 7.40498C16.7943 4.5105 14.4479 2.16406 11.5534 2.16406C8.65894 2.16406 6.3125 4.5105 6.3125 7.40498C6.3125 10.2995 8.65894 12.6459 11.5534 12.6459Z"
          fill={color || theme.color.icon.icon_4}
        />
        <path
          d="M11.0762 11.6914C12.0047 11.6914 12.9046 11.8427 13.751 12.1211C13.1972 12.5673 12.7201 13.1045 12.3418 13.71C11.9332 13.6364 11.5105 13.5967 11.0762 13.5967C7.18929 13.5967 4.21484 16.6861 4.21484 20.2676C4.21447 20.7935 3.83083 21.2197 3.35742 21.2197C2.8841 21.2196 2.50038 20.7934 2.5 20.2676C2.5 15.4287 6.43751 11.6914 11.0762 11.6914Z"
          fill={color || theme.color.icon.icon_4}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5592 17.077C14.5592 18.8312 15.9813 20.2533 17.7355 20.2533C19.4898 20.2533 20.9118 18.8312 20.9118 17.077C20.9118 15.3227 19.4898 13.9007 17.7355 13.9007C15.9813 13.9007 14.5592 15.3227 14.5592 17.077ZM12.9711 17.077C12.9711 19.7083 15.1042 21.8414 17.7355 21.8414C20.3669 21.8414 22.5 19.7083 22.5 17.077C22.5 14.4456 20.3669 12.3125 17.7355 12.3125C15.1042 12.3125 12.9711 14.4456 12.9711 17.077Z"
          fill={color || theme.color.icon.icon_4}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8759 18.8976L19.5538 14.2198L20.5645 15.2305L15.8866 19.9083L14.8759 18.8976Z"
          fill={color || theme.color.icon.icon_4}
        />
      </svg>
    </i>
  );
}
